
import {Component, Vue} from "vue-property-decorator";
import FormWrapper from "@/components/FormWrapper.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import {StatusCodeHelper} from "@/helpers/StatusCodeHelper";
import {VekaletUcretiHesapTablosu, VekaletUcretiSonucu} from "@/helpers/VekaletUcretiHesapTablosu";

interface Secenek {
  kod: string;
  ad: string;
}

const ICRA_TAKIBI = "icra_takibi";

/**
 * DEV-2431 — Takip açmadan AAÜT'ye göre vekâlet ücreti.
 * Alanlar ve sonuç tablosu TBB hesaplama aracının düzenini izler; tutarlar
 * API'den, veritabanımızdaki tarifeden gelir.
 */
@Component({
  components: {FormWrapper, Tutar},
})
export default class VekaletUcretiHesaplayiciView extends Vue {
  tablo = VekaletUcretiHesapTablosu;
  secenekler: { islem_turleri: Array<Secenek>; mahkemeler: Array<Secenek> } = {islem_turleri: [], mahkemeler: []};
  form: { tutar: number | null; islemTuru: string; mahkemeKodu: string | null } = {
    tutar: null,
    islemTuru: "konusu_para",
    mahkemeKodu: null,
  };
  sonuc: VekaletUcretiSonucu | null = null;
  hataMesaji: string | null = null;

  get mahkemeSecilir(): boolean {
    return this.form.islemTuru !== ICRA_TAKIBI;
  }

  get donemTarihi(): string {
    return this.sonuc ? this.sonuc.tarife_donemi.baslangic_tarihi.split("-").reverse().join(".") : "";
  }

  mounted() {
    this.secenekleriGetir();
  }

  secenekleriGetir() {
    this.$http.get("/api/v1/hesaplayicilar/vekalet-ucreti-hesaplayici/secenekler")
        .then((yanit: any) => {
          this.secenekler = yanit.data;
          this.ilkMahkemeyiSec();
        })
        .catch(() => {
          this.hataMesaji = "Seçenekler yüklenemedi. Sayfayı yenileyip tekrar deneyin.";
        });
  }

  islemTuruDegisti() {
    this.sonuc = null;
    if (this.form.islemTuru === ICRA_TAKIBI) {
      this.form.mahkemeKodu = null;
    } else {
      this.ilkMahkemeyiSec();
    }
  }

  // TBB ekranındaki gibi listedeki ilk mahkeme seçili gelir.
  ilkMahkemeyiSec() {
    if (this.mahkemeSecilir && !this.form.mahkemeKodu && this.secenekler.mahkemeler.length) {
      this.form.mahkemeKodu = this.secenekler.mahkemeler[0].kod;
    }
  }

  hesapla() {
    this.hataMesaji = null;
    if (!this.form.tutar || this.form.tutar <= 0) {
      this.hataMesaji = "Dava / Takip Tutarı sıfırdan büyük olmalı.";
      return;
    }

    StatusCodeHelper.dontShow422Alert = true;
    this.$http.post("/api/v1/hesaplayicilar/vekalet-ucreti-hesaplayici", {
      tutar: this.form.tutar,
      islem_turu: this.form.islemTuru,
      mahkeme_kodu: this.mahkemeSecilir ? this.form.mahkemeKodu : null,
    }).then((yanit: any) => {
      this.sonuc = yanit.data;
      StatusCodeHelper.dontShow422Alert = false;
    }).catch((hata: any) => {
      this.sonuc = null;
      this.hataMesaji = this.dogrulamaHatasi(hata);
      StatusCodeHelper.dontShow422Alert = false;
    });
  }

  // 422 dışındaki hatalar genel uyarıyla zaten gösteriliyor.
  dogrulamaHatasi(hata: any): string | null {
    const yanit = hata && hata.response;
    if (!yanit || yanit.status !== 422) {
      return null;
    }
    const hatalar = yanit.data && yanit.data.errors;
    if (hatalar) {
      return ([] as Array<string>).concat(...(Object.values(hatalar) as Array<Array<string>>)).join(" ");
    }
    return (yanit.data && yanit.data.message) || "Girilen bilgilerle hesaplama yapılamadı.";
  }
}
